var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightFromBracket = function SvgArrowRightFromBracket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.126 12.424 21.55 12l-.424-.424-4.8-4.8-.424-.423-.847.847.424.424 3.776 3.776H8.402v1.2h10.853l-3.776 3.776-.424.424.847.848.424-.424zM9.002 4.8h.6V3.6h-7.2v16.8h7.2v-1.2h-6V4.8z"
  })));
};
export default SvgArrowRightFromBracket;